export default "__VITE_ASSET__DI4txPty__"